import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import OAuthSDKDark from "@/common/assets/image/products/icons/OAuthSDKDark.svg"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"

const OAuthSdkPage = () => {
  const { t } = useTranslation(["oauthsdk"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/oauth-sdk"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/oauth-sdk"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/oauth-sdk"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/oauth-sdk"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={OAuthSDKDark.src}
          bannerType={ProductNames.OAuthSDK}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          checkList={[
            {
              listColor: "disabled",
              list: [
                { description: t("Banner.checkList.item1") },
                { description: t("Banner.checkList.item2") },
                { description: t("Banner.checkList.item3") }
              ]
            }
          ]}
        />
        <div style={{ padding: "5vh 0 0 0" }}>
          <SectionLine />
        </div>
        <Description
          items={[
            {
              titles: [{ text: t("Desc.1.title") }],
              content: t("Desc.1.content")
            },
            {
              titles: [{ text: t("Desc.2.title") }],
              content: t("Desc.2.content")
            },
            {
              titles: [{ text: t("Desc.3.title") }],
              content: t("Desc.3.content")
            }
          ]}
        />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.desc")}
          primaryButton={{ text: t("CTA.button") }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.NFTBoost,
                ProductNames.WalletBuilder,
                ProductNames.User360
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "oauthsdk"
    ]))
  }
})

export default OAuthSdkPage
